export default "__VITE_ASSET__CIbzshb5__"